import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { Utils } from "../../../Shared/utils";
import { CurrencyPipe, Location } from "@angular/common";
import { ApiServiceService } from "../../../Services/api-service.service";
import { AuthService } from "../../../Services/auth.service";
import { BsModalService } from "ngx-bootstrap/modal";
import alertify from "alertifyjs";
import { ViewMdaBillDetailsComponent } from "../view-mda-bill-details/view-mda-bill-details.component";
import { environment } from "../../../../environments/environment";
import { PublicPaymentModalComponent } from "../public-payment-modal/public-payment-modal.component";
import { Observable } from "rxjs";
import { ErrorDialogComponent } from "src/app/Shared/shared/error-dialog/error-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MdaGenerateBillsModalComponent } from "../../Admin/mda/mda-generate-bills-modal/mda-generate-bills-modal.component";
import { ReconcileMdaBilsManualComponent } from "../reconcile-mda-bils-manual/reconcile-mda-bils-manual.component";

@Component({
  selector: "app-search-mda-bill-history",
  templateUrl: "./search-mda-bill-history.component.html",
  styleUrls: ["./search-mda-bill-history.component.css"],
  providers: [CurrencyPipe],
})
export class SearchMdaBillHistoryComponent implements OnInit {
  @ViewChild("uploadInput", { static: false })
  uploadInput!: ElementRef<HTMLInputElement>;

  isEmpty: boolean = false;
  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  details: any;
  isLoading: any;
  isSearching: any;
  count: number = 0;
  pageSize: number = 5;
  searchForm: any = FormGroup;
  showSearch: boolean = false;
  tempRevenueType: string;
  countDetails: any;
  showFilters = false;
  minDate: any;
  lottiePath = "assets/lottie/no-data.json";
  preferredCountries: string[] = ["ng", "us", "gb"];
  countryISO: CountryISO = CountryISO.Nigeria;
  protected readonly SearchCountryField = SearchCountryField;
  numbersOnly = Utils.numberOnly;
  form: FormGroup;
  mdaForm: FormGroup;
  searching: boolean;
  asinForm: FormGroup;
  hasPayerData = false;
  mda: any;
  mda$: Observable<any[]>;
  revenueCode: string;
  revenueName: string;
  serviceType: string;
  assessmentSearchForm: any = FormGroup;
  transactionType: string;
  showVariable: boolean;
  showPeriodIsApplicable: boolean;
  showLocationIsApplicable: boolean;
  showUploadsIsApplicable: boolean;
  showLandParamIsApplicable: boolean;
  lgas: any[] = [];
  areas: any[] = [];
  onPreview: boolean = false;
  uploaded: string = "";
  safePdfUrl: any = null;
  selecteMdaName: string = "";
  selectedYear: string = "";

  paymentReferenceForm: any = FormGroup;
  isVerifyingRrr: boolean;
  paymentDetails: any;
  bill: any;
  asin: string;
  amount: any;

  constructor(
    private location: Location,
    private fb: FormBuilder,
    private apiService: ApiServiceService,
    private authService: AuthService,
    private bsModalService: BsModalService,
    private modalService: BsModalService,
    private ngbModal: NgbModal,
    private el: ElementRef,
  ) {
    this.assessmentSearchForm = this.fb.group({
      paymentStatus: [""],
      invoice: [""],
      from: [""],
      to: [""],
      asin: [""],
      offset: [""],
    });
  }

  @ViewChild("table") myDiv!: ElementRef;
  ngOnInit(): void {
    this.search();
    this.initializeForm();
    setTimeout(() => {
      this.myDiv.nativeElement.style.backgroundColor =
        this.authService.getSecondaryColor();
      const links = this.el.nativeElement.querySelectorAll("h6");
      links.forEach((link: HTMLElement) => {
        link.style.color = this.authService.getSecondaryTextColor();
      });
    });
  }

  initiatePaymentReferenceForm() {
    this.paymentReferenceForm = this.fb.group({
      rrr: ["", [Validators.required]],
    });
  }

  openManualReconciliation() {
    let dfModalRef = this.bsModalService.show(ReconcileMdaBilsManualComponent, {
      initialState: {
        paymentDetails: this.paymentDetails,
        bill: this.bill,
      },
      class: "modal-lg modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }

  confirmPaymentReference() {
    this.isVerifyingRrr = true;
    this.paymentDetails = null;

    const url = "/assessments/verify-payment/rrr";

    this.apiService.post(url, this.paymentReferenceForm.value).subscribe(
      (response) => {
        this.paymentDetails = response.data;

        this.isVerifyingRrr = false;

        if (this.paymentDetails?.message == "Payment found") {
          if (this.paymentDetails?.reconciliation == true) {
            this.confirmAfterError("Payment has already been used");
          } else if (this.paymentDetails?.revenueCode != this.revenueCode) {
            this.confirmAfterError(
              "The billing revenue code does not align with the payment code",
            );
          } else if (this.paymentDetails?.asin != this.asin) {
            this.confirmAfterError(
              "The billing ASIN does not align with the payment ASIN",
            );
          } else if (this.paymentDetails?.amount < this.amount) {
            this.confirmAfterError("Insufficient amount");
          } else {
            this.openManualReconciliation();
          }
        } else {
          this.confirmAfterError(this.paymentDetails?.message);
          alertify.set("notifier", "position", "top-center");
          alertify.error(this.paymentDetails?.message);
        }
      },
      (error) => {
        this.isVerifyingRrr = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
      },
    );
  }

  isImage(documentUpload: any): boolean {
    return (
      typeof documentUpload === "string" &&
      documentUpload.startsWith("data:image/")
    );
  }

  isFileImage(file: File): boolean {
    return file?.type?.startsWith("image/") ?? false;
  }

  isFilePDF(file: File): boolean {
    return file?.type === "application/pdf";
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
  confirmAfterError(message: any) {
    let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }

  getLgas() {
    let url = "/auth/lga/all";

    this.apiService.LoginGet(url).subscribe(
      (response) => {
        this.lgas = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getAreas() {
    let lgaId = this.mdaForm.get("lga")?.value;

    let url = `/auth/area/all/${lgaId}`;

    this.apiService.LoginGet(url).subscribe(
      (response) => {
        this.areas = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  search() {
    this.details = [];
    this.countDetails = {};
    var formData: any = new FormData();
    this.isEmpty = false;
    this.isSearching = true;
    this.num = this.page * 5;
    const url = "/assessments/search/generated-bills";
    formData.append("offset", this.num);
    formData.append("invoice", this.assessmentSearchForm.get("invoice").value);
    formData.append(
      "paymentStatus",
      this.assessmentSearchForm.get("paymentStatus").value,
    );
    formData.append("asin", this.assessmentSearchForm.get("asin").value);
    formData.append("to", this.assessmentSearchForm.get("to").value);
    formData.append("from", this.assessmentSearchForm.get("from").value);

    if (this.hasAccess(["ALL_MDA_PERMISSIONS"])) {
      const mdaId = this.authService.getDept();

      formData.append("mda", mdaId);
    }

    if (!this.hasAccess(["ALL_MDA_PERMISSIONS"])) {
      formData.append("user", this.authService.getId());
    }

    this.apiService.post(url, formData).subscribe(
      (response) => {
        this.details = response?.results;
        if (this.details.length > 0) {
          this.isLoading = false;
          this.count = Math.ceil(response.total);
          this.isSearching = false;
          this.showFilters = false;
        } else {
          this.isLoading = false;
          this.isSearching = false;
          this.isEmpty = true;
          this.showFilters = false;
        }
      },
      (error) => {
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isEmpty = true;
        this.isSearching = false;
      },
    );
  }

  goBack() {
    this.location.back();
  }

  toggleFilter(): void {
    this.showFilters = !this.showFilters;
  }

  now(): Date {
    return new Date();
  }

  get minDateValue(): any {
    return this.minDate;
  }

  initializeForm(): void {
    this.asinForm = this.fb.group({
      asin: [""],
    });
    this.form = this.fb.group({
      name: [""],
      asin: ["", [Validators.required]],
      phoneNumber: [""],
      email: [""],
    });

    this.mdaForm = this.fb.group({
      mda: ["", [Validators.required]],
      serviceType: ["", [Validators.required]],
      paymentPeriod: ["", [Validators.required]],
      transactionDescription: ["", [Validators.required]],
      paymentAmountDue: ["", [Validators.required]],
      transactionAmount: ["", [Validators.required]],
      percentage: ["", [Validators.required]],
      lga: ["", [Validators.required]],
      area: ["", [Validators.required]],
      address: ["", [Validators.required]],
      landSize: [
        "",
        [
          Validators.required,
          Validators.min(1),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      period: ["", [Validators.required]],
      upload: ["", [Validators.required]],
    });
  }

  clearUpload() {
    this.uploadInput.nativeElement.value = "";
    this.mdaForm.patchValue({ upload: null });
  }

  get upload() {
    return this.mdaForm.get("upload") as FormControl;
  }

  triggerUpload() {
    this.uploadInput.nativeElement.click();
  }

  onUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];

      this.mdaForm?.patchValue({ upload: file });
    }
  }

  openCreateNewBill(asinDetails: any, asin: string): void {
    let bsModalRef = this.modalService.show(MdaGenerateBillsModalComponent, {
      initialState: {
        asinDetails: asinDetails,
        asin: asin,
      },
      backdrop: true,
      class: "modal-lg generate-bills-modal modal-dialog-centered",
      ignoreBackdropClick: true,
    });

    if (bsModalRef?.content?.onConfirmClicked) {
      bsModalRef.content.onConfirmClicked.subscribe((v: any) => {
        bsModalRef.hide();
      });
    }
  }

  verifyAsin(): void {
    this.searching = true;
    this.asinForm.markAllAsTouched();
    if (!this.asinForm.valid || this.asinForm?.get("asin")?.value === "") {
      this.searching = false;
      return;
    }
    this.apiService
      .post(
        "/assessments/get/asin?asin=" + this.asinForm?.get("asin")?.value,
        {},
      )
      .subscribe({
        next: (res: any) => {
          this.searching = false;
          this.hasPayerData = true;
          if (res) {
            this.openCreateNewBill(res, this.asinForm?.get("asin")?.value);
          }
        },
        error: (err: any) => {
          console.log(err.message);
          this.searching = false;
          alertify.set("notifier", "position", "top-center");
          alertify.error("Invalid asin details");
          console.log(err);
        },
      });
  }

  get currencySymbol(): string {
    return Utils.currencySymbol("NGN");
  }

  viewDetails(billDetails: any) {
    let dfModalRef = this.bsModalService.show(ViewMdaBillDetailsComponent, {
      initialState: {
        billDetails: billDetails,
      },
      class: "modal-lg modal-dialog-centered",
      ignoreBackdropClick: true,
      animated: true,
    });
  }

  payOnline(bill: any) {
    const returnBackUrl = `${environment?.url}/payment/successful-payment`;
    this.isLoading = false;
    console.log(bill);

    let requestRemitaRRR = {
      returnBackUrl: returnBackUrl,
      totalAmount: bill?.transactionAmount,
      fullName: bill?.taxpayerDisplayName,
      customerId: bill?.taxpayerAsin,
      revenueName: bill?.revenueName,
      revenueId: bill?.revenueCode,
      email: bill?.taxpayerEmail,
      taxGroup: "INDIVIDUAL",
      phoneNumber: bill?.taxpayerPhoneNumber,
      feeDescription: bill?.revenueDescription,
      entityName: bill?.revenueName,
      entityType: "MDA",
      entityGroup: bill?.serviceType,
      accessedBy: this.authService.getDisplayName(),
      mdaRecordId: bill?.revenueId,
    };

    let bsModalRef = this.modalService.show(PublicPaymentModalComponent, {
      initialState: {
        details: requestRemitaRRR,
      },
      backdrop: true,
      class: "modal-md modal-dialog-centered",
      ignoreBackdropClick: true,
    });
    bsModalRef?.content?.onConfirmClicked.subscribe((v) => {
      bsModalRef.hide();
    });
  }

  isDownloading: boolean = false;

  downloadNotice(id: number, name: string) {
    this.isDownloading = true;
    let url = `/assessments/download/mda/bills?id=${id}`;

    this.apiService.post(url, {}, { responseType: "blob" }).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: "application/pdf" });

        // Create a Blob URL for the PDF content
        const blobUrl = window.URL.createObjectURL(blob);

        // Open PDF in a new tab
        // window.open(blobUrl, '_blank');

        const file = new Blob([response], { type: "application/pdf" });

        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        // Optionally, trigger a download by creating an anchor element
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.target = "_blank";
        downloadLink.download = name + "_demand_notice.pdf"; // File name for download

        // Uncomment this line to trigger the download automatically
        downloadLink.click();

        alertify.set("notifier", "position", "top-center");
        alertify.success("Download successful");
        this.isDownloading = false;
      },
      (error) => {
        this.isDownloading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isEmpty = true;
      },
    );
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  open(content: any) {
    this.ngbModal.open(content, { centered: true, size: "md" });
  }

  openPayment(content: any) {
    this.ngbModal.open(content, { centered: true, size: "md" });

    this.initiatePaymentReferenceForm();
  }

  selectId(bill) {
    this.bill = bill;
    this.revenueCode = bill?.revenueCode;
    this.asin = bill?.taxpayerAsin;
    this.amount = bill?.transactionAmount;
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions);
  }

  downloadPaymentReceipt(rrr: string) {
    let url = "/assessments/print/payment/receipt";

    let dto = {
      rrr: rrr,
    };

    this.apiService.post(url, dto, { responseType: "blob" }).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: "application/pdf" });

        // Create a Blob URL for the PDF content
        const blobUrl = window.URL.createObjectURL(blob);

        // Open PDF in a new tab
        // window.open(blobUrl, '_blank');

        const file = new Blob([response], { type: "application/pdf" });

        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        // Optionally, trigger a download by creating an anchor element
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.target = "_blank";
        downloadLink.download = "payment_receipt.pdf"; // File name for download

        // Uncomment this line to trigger the download automatically
        downloadLink.click();

        alertify.set("notifier", "position", "top-center");
        alertify.success("Download successful");
      },
      (error) => {
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
      },
    );
  }
}

export interface MDABillDto {
  taxpayerDisplayName: string;
  taxpayerAsin: string;
  mdaId: number;
  mda: number;
  paymentPeriod: string;
  serviceType: string;
  transactionAmount: string;
  transactionDescription: string;
  taxpayerEmail?: string;
  taxpayerPhoneNumber?: string;
  revenueCode?: string;
  revenueName?: string;
  createdById?: string;
  createdByName?: string;
  revenueId?: string;

  lga: number;
  area: number;
  address: string;
  landSize: number;
  period: string;
  upload: string;
  customMDAUploadables: any[];
  customMDADetailId: string;
  customMDAServiceType: string;
}
